import React from 'react';
import {
    Grid, FormControlLabel, Checkbox,
    Typography, Box, Paper
} from '@mui/material';
import { AMENITY_CATEGORIES } from '../../constants/amenities';

function AmenitiesInfo({ onChange, value = [] }) {
    const handleChange = (amenity) => (event) => {
        const isChecked = event.target.checked;
        const newAmenities = isChecked
            ? [...value, amenity]
            : value.filter(item => item !== amenity);
        onChange(newAmenities);
    };

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                アメニティ
            </Typography>
            <Grid container spacing={3}>
                {Object.entries(AMENITY_CATEGORIES).map(([category, amenities]) => (
                    <Grid item xs={12} key={category}>
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="subtitle1" gutterBottom>
                                {category}
                            </Typography>
                            <Grid container>
                                {amenities.map(({ value: amenity, label }) => (
                                    <Grid item xs={12} sm={6} md={4} key={amenity}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={value.includes(amenity)}
                                                    onChange={handleChange(amenity)}
                                                    name={amenity}
                                                />
                                            }
                                            label={label}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default AmenitiesInfo; 